export const environment = {
    adminPortalUrl: 'https://rs.nic.in/join',
    webSocketServer: 'wss://lk.rs.nic.in',
    controlServerEndpoint: 'https://cs.rs.nic.in/controlServer',
    contentService: 'https://ssr.rs.nic.in',
    disableJoinBtn: true,
    huddleClientVersion: "2.1.2",
    tenantAlias: 'nic',
    sessionRejoinTimeout: 120000,
    fileSharingConstraints: {
        fileSharingLimit: 20 * 1024 * 1024,
        allowedFileExtensions: ["pdf", "doc", "docx", "txt", "csv", "xls", "xlsx", "ppt", "pptx", "jpg", "jpeg", "png", "zip", "text", "gzip", "tar", "tgz", "rar", "7z"]
    }
}